<template>
  <div class="row jipvio-dashboard">
    <div class="col-12">
      <card class="mt-70" card-body-classes="table-full-width" no-footer-line>
        <h4 class="card-title ml-20 mb-30">계약관리 > 계약일정</h4>
        <div class="col-11">
          <p class="ml-10 fl" style="width: 80%">
            임대차 계약일정을 등록하여 관리하실 수 있습니다.
          </p>
          <router-link to="/mypage/cont/mgmt">
            <el-button class="fr" icon="el-icon-menu">목록보기</el-button>
          </router-link>
        </div>
        <div class="col-12 row">
          <div class="row col-lg-6 ml-10">
            <!-- 주소 -->
            <h4>매물정보</h4>
            <div class="col-12 pl-0 mb-30">
              <label>매물주소</label>
              <el-input class="" v-model="input">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <div class="col-12 pl-0 mb-30 pr-0">
              <label class="col-12 pl-0 mb-10">상세주소</label>
              <el-input class="col-md-6 pl-0 mb-10" v-model="input">
                <template slot="append">동</template>
              </el-input>
              <el-input class="col-md-6 pl-0 mb-10" v-model="input">
                <template slot="append">호</template>
              </el-input>
              <el-input class="col-md-6 pl-0 mb-10" v-model="input">
                <template slot="append">층</template>
              </el-input>
              <el-input class="col-md-6 pl-0 mb-10">
                <template slot="append">명칭</template>
              </el-input>
            </div>
            <div class="col-12 pl-0 mb-30 pr-0">
              <label class="">주소정보</label>
              <div class="col-12 pl-0">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="Please input"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="row col-lg-6 KakaoMap">
            <!--kakao map location-->
            <kakao></kakao>
          </div>
        </div>
        <div class="col-10 mb-30 ml-10">
          <h4>계약일정</h4>
          <el-input
            class="col-md-4 pl-0 mb-10 pr-10"
            v-model="input"
            suffix-icon="el-icon-date"
          >
            <template slot="prepend">계약일자</template>
          </el-input>
          <el-input
            class="col-md-4 pl-0 mb-10 pr-10"
            v-model="input"
            suffix-icon="el-icon-date"
          >
            <template slot="prepend">중도금일자</template>
          </el-input>
          <el-input
            class="col-md-4 pl-0 mb-10 pr-10"
            v-model="input"
            suffix-icon="el-icon-date"
          >
            <template slot="prepend">잔금일자</template>
          </el-input>
        </div>
        <div class="col-10 mb-30 ml-10">
          <h4>임대인정보</h4>
          <el-input class="col-md-4 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">성명</template>
          </el-input>
          <el-input class="col-md-4 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">연락처</template>
          </el-input>
        </div>
        <div class="col-10 mb-30 ml-10">
          <h4>임차인정보</h4>
          <el-input class="col-md-4 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">성명</template>
          </el-input>
          <el-input class="col-md-4 pl-0 mb-10 pr-10" v-model="input">
            <template slot="prepend">연락처</template>
          </el-input>
        </div>
        <div class="col-12 ml-10">
          <h4>메모</h4>
          <ckeditor
            class="col-11 mb-30 pl-0"
            v-model="editorDataMemo"
            :config="editorConfig"
          ></ckeditor>
          <div class="col-11 mb-50">
            <el-button
              class="fr"
              icon="el-icon-circle-plus
"
              >일정등록</el-button
            >
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import card from "@/components/Cards/Card.vue";
import CKEditor from "ckeditor4-vue";
import { Input, Button } from "element-ui";
import kakao from "@/pages/jipvio/kakaoMap.vue";

export default {
  components: {
    card,
    ckeditor: CKEditor.component,
    [Input.name]: Input,
    [Button.name]: Button,
    kakao
  },
  created() {
    console.log("===detail");
  },
  computed: {},
  data() {
    return {
      input: "",
      editorDataMemo: "<p>내용을 입력해주세요.</p>",
      editorConfig: {
        toolbar: [
          ["Styles", "Format", "Font", "FontSize"],
          ["Bold", "Italic"],
          ["TextColor", "BGColor"],
          [
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Blockquote",
            "CreateDiv",
            "-",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "BidiLtr",
            "BidiRtl",
            "Language"
          ],
          ["Table"],
          ["Link"],
          ["Undo", "Redo"],
          ["About"]
        ]
        // The configuration of the editor.
      }
    };
  },
  methods: {},
  mounted() {},
  watch: {}
};
</script>
<style>
.jipvio-dashboard .el-input__suffix {
  right: 14px;
}
div.KakaoMap > div {
  width: 100%;
}
div#map {
  width: 600px;
  height: 500px;
  margin: 0 auto !important;
}
div#map ~ button {
  display: none;
}
</style>
